import { computed, Fragment, h, unref } from 'vue';

import { paramCase, propsFactory } from '@components/utils';

import type { MaybeRef } from '@components/utils';
import type { ComputedRef, PropType } from 'vue';

export type TVariant = typeof allowedVariant[number];

export interface IVariantProps {
  variant: TVariant;
}

export interface IUseVariant {
  variantClasses: ComputedRef<string>;
}

export const allowedVariant = ['default', 'compact', 'important'] as const;

export const makeVariantProps = propsFactory(
  {
    variant: {
      type: String as PropType<TVariant>,
      default: 'default',
      validator: (value: TVariant) => allowedVariant.includes(value)
    }
  },
  'variant'
);

export function useVariant(props: MaybeRef<IVariantProps>, name: string): IUseVariant {
  const variantClasses = computed(() => {
    const { variant } = unref(props);
    return `${paramCase(name)}__variant--${variant}`;
  });

  return { variantClasses };
}

export function genOverlays(isClickable: boolean, name: string) {
  return h(Fragment, [
    isClickable && h('span', { key: 'overlay', class: `${name}__overlay` }),
    h('span', { key: 'underlay', class: `${name}__underlay` })
  ]);
}
